module.exports = __webpack_public_path__ + "img/1_EN_ChineseMicrosite_Homepage_HeroImage.00a15ecc.jpg";